// extracted by mini-css-extract-plugin
export default {"container":"ingredient-details_container__97I2W","info":"ingredient-details_info__k66nb","image":"ingredient-details_image__dZ8AY","list":"ingredient-details_list__m-97x"};